import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Select } from '../../../../../../../../../../CommonComponents/OPL/Select/Select/Select';
import { Box } from '../../../../../../../../../../CommonComponents/OPL/Box/Box';
import { TaxStatusDTO } from '../../../../../../../../api/useAccountsQuery';
import { useAccountFormContext } from '../../../../context/useAccountFormContext';

interface Props {
  selectedTaxStatus: number | null;
  setSelectedTaxStatus: (selectedTaxStatus: number | null) => void;
}

export const TaxStatus = (props: Props) => {
  const { watch } = useFormContext();

  const [accountTaxStatus] = watch(['bankAccount.TaxStatus']);

  if (accountTaxStatus !== TaxStatusDTO.Mix) {
    return null;
  }

  return <TaxStatusDropdown {...props} />;
};

const TaxStatusDropdown = ({ selectedTaxStatus, setSelectedTaxStatus }: Props) => {
  const { watch, formState } = useFormContext();

  const accountType = watch('bankAccount.AccountType');

  const {
    options: { AccountTypeOptions },
  } = useAccountFormContext();

  const accountTypeOptions = AccountTypeOptions.find(option => option.AccountType === accountType);

  if (!accountTypeOptions) {
    throw new Error('Account type not found');
  }
  const { AssetAllocationTaxStatuses: assetAllocationTaxStatuses } = accountTypeOptions;

  const assetAllocationTaxStatusesOptions = assetAllocationTaxStatuses.map(({ Label, Value }) => ({
    label: Label,
    value: Value,
  }));

  return (
    <Box width="50%" mt="16">
      <Select
        value={assetAllocationTaxStatusesOptions.find(({ value }) => value === selectedTaxStatus)}
        options={assetAllocationTaxStatusesOptions}
        onChange={opt => {
          return setSelectedTaxStatus(opt ? opt.value : null);
        }}
        label="Tax Status"
        placeholder="Tax Status"
        disabled={formState.disabled}
        isPortal
        isClearable
      />
    </Box>
  );
};
